<template>
  <div>
    <div data-app v-if="reportData == null && !reportFlag">
      <template v-if="$store.getters.currentMerchant">
        <div class="mt-4">
          <!-- <ValidationObserver> -->
          <template>
            <v-container>
              <v-row>
                <v-col cols="12" class="px-5 mb-4">
                  <v-img
                    v-if="stepper == 1"
                    :src="$store.getters.tradeImageSrc1"
                    max-height="150px"
                  >
                  </v-img>
                  <v-img
                    v-if="stepper == 2"
                    :src="$store.getters.tradeImageSrc2"
                    max-height="150px"
                  >
                  </v-img>
                  <v-img
                    v-if="stepper == 3"
                    :src="$store.getters.tradeImageSrc3"
                    max-height="150px"
                  >
                  </v-img>
                  <v-img
                    v-if="stepper == 4"
                    :src="$store.getters.tradeImageSrc4"
                    max-height="150px"
                  >
                  </v-img>
                </v-col>
              </v-row>
              <!-- ------------------------------------------------ -->
              <h6>
                در صورت نیاز به راهنمای استفاده روی آیکون
                <i class="fas fa-exclamation-circle text-primary"></i>
                کلیک کنید
              </h6>

              <v-stepper v-model="stepper" vertical>
                <!-- <v-form ref="firstStep" v-model="firstFormValid"> -->
                <v-stepper-step :complete="stepper > 1" step="1">
                  <v-row class="pa-2">
                    <!-- <v-col cols="12"> -->
                    <h5
                      class="text--secondary"
                      v-if="!$store.getters.tradeRequestIsEdit"
                    >
                      ثبت اطلاعات عمومی
                    </h5>
                    <h5
                      class="text--secondary"
                      v-else-if="$store.getters.tradeRequestIsEdit && !editFlag"
                    >
                      مشاهده اطلاعات عمومی
                    </h5>
                    <h5
                      class="text--secondary"
                      v-else-if="$store.getters.tradeRequestIsEdit && editFlag"
                    >
                      ویرایش اطلاعات عمومی
                    </h5>
                    <HelperComponent
                      helperId="trade-request-general-info"
                      class="mx-2"
                    />

                    <!-- </v-col> -->
                  </v-row>
                </v-stepper-step>

                <v-stepper-content step="1">
                  <v-form ref="firstStep" v-model="firstFormValid">
                    <v-sheet
                      outlined
                      class="pa-4 my-4"
                      v-if="
                        !$store.getters.tradeRequestIsEdit ||
                        ($store.getters.tradeRequestIsEdit && editFlag)
                      "
                    >
                      <v-row class="">
                        <!-- <v-col cols="12"> -->

                        <!-- <v-row class="my-3"> -->
                        <v-col cols="12" md="4">
                          <v-select
                            item-text="displayName"
                            item-value="title"
                            :items="tradeRequestTypeList"
                            v-model="tradeRequest.request"
                            dense
                            required
                            :rules="[
                              (v) => !!v && v !='DirectOrder' || 'یک مورد مناسب(غیر از سفارش مستقیم) انتخاب کنید',
                            ]"
                            outlined
                            label="موضوع سفارش*"
                            @change="requestTypeSelectionChange()"
                          >
                          </v-select>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-select
                            item-text="displayName"
                            item-value="title"
                            :items="tradeCategoriesList"
                            v-model="tradeRequest.category"
                            dense
                            outlined
                            required
                            :rules="[
                              (v) => !!v || 'وارد کردن مقدار الزامی میباشد',
                            ]"
                            :readonly="
                              $store.getters.tradeRequestIsEdit ||
                              (tradeRequest.items && tradeRequest.items.length)
                                ? true
                                : false
                            "
                            label="نوع سفارش*"
                          >
                          </v-select>
                        </v-col>

                        <v-col
                          cols="12"
                          md="4"
                          v-if="
                            tradeRequest &&
                            tradeRequest.request != 'ContractorRecognition'
                          "
                        >
                          <v-select
                            item-text="displayName"
                            item-value="title"
                            :items="tradePaymentMethodList"
                            v-model="tradeRequest.paymentMethod"
                            dense
                            outlined
                            required
                            :rules="[
                              (v) => !!v || 'وارد کردن مقدار الزامی میباشد',
                            ]"
                            label="روش پرداخت/تسویه*"
                          >
                          </v-select>
                        </v-col>
                        <v-col cols="12" md="4" v-else>
                          <v-select
                            item-text="displayName"
                            item-value="title"
                            :items="tradeGuaranteeList"
                            v-model="tradeRequest.guarantee"
                            dense
                            outlined
                            :required="
                              tradeRequest &&
                              tradeRequest.request == 'ContractorRecognition'
                            "
                            :rules="[
                              (v) => !!v || 'وارد کردن مقدار الزامی میباشد',
                            ]"
                            label="نوع تضمین موردنظر *"
                          >
                          </v-select>
                        </v-col>
                        <!-- </v-row> -->

                        <!-- </v-col> -->

                        <v-col
                          cols="12"
                          v-if="tradeRequest.category == 'Product'"
                        >
                          <!-- <div> -->
                          <v-checkbox
                            class="mt-n3 mr-n3"
                            v-model="tradeRequest.requestIsForManufaturer"
                            label="ارجاع فقط برای ساخت"
                          ></v-checkbox>
                          <!-- </div> -->
                        </v-col>
                        <v-col cols="12">
                          <v-row>
                            <v-col cols="12" md="4" sm="6">
                              <span
                                class="text-right"
                                v-if="
                                  tradeRequest &&
                                  tradeRequest.request ==
                                    'ContractorRecognition'
                                "
                              >
                                لطفا مهلت شرکت در سفارش را مشخص کنید.*
                              </span>
                              <span class="text-right" v-else>
                                لطفا مهلت شرکت در
                                {{
                                  tradeRequestDisplayName(tradeRequest.request)
                                }}
                                را مشخص کنید.*
                              </span>
                            </v-col>

                            <v-col cols="8" sm="6" md="4" lg="3" class="mr-n2">
                              <v-row>
                                <!-- <ValidationProvider name=" مهلت شرکت" rules="required"> -->

                                <v-text-field
                                  v-model="bidExpirationTimeInDaysFromNow"
                                  dense
                                  outlined
                                  type="number"
                                  value="1"
                                  placeholder="صفحه کلید به انگلیسی باشد"
                                  style="width: 80px"
                                  suffix="روز"
                                  required
                                  :rules="[
                                    (v) =>
                                      !!v || 'وارد کردن مقدار الزامی میباشد',
                                  ]"
                                  class="mx-5"
                                ></v-text-field>
                                <!-- </ValidationProvider> -->
                                <span class="mt-3">
                                  <!-- {{addHoursToDate(tradeRequest.bidExpirationTimeInDays)}} -->
                                  {{
                                    jalaliDate(
                                      addDaysToDate(
                                        tradeRequest.bidExpirationTimeInDays
                                      )
                                    )
                                  }}
                                </span>
                              </v-row>
                            </v-col>
                            <v-col cols="1" md="5"></v-col>
                          </v-row>
                          <v-row
                            v-if="
                              tradeRequest &&
                              tradeRequest.request == 'ContractorRecognition'
                            "
                          >
                            <v-col cols="12" md="4" sm="6">
                              <span class="text-right">
                                لطفا مدت اجرای طرح را مشخص کنید.
                              </span>
                            </v-col>

                            <v-col cols="8" sm="6" md="4" lg="3" class="mr-n2">
                              <v-row>
                                <v-text-field
                                  v-model="tradeRequest.runningDuration"
                                  dense
                                  outlined
                                  type="number"
                                  placeholder="صفحه کلید به انگلیسی باشد"
                                  style="width: 80px"
                                  suffix="ماه"
                                  required
                                  :rules="[
                                    (v) =>
                                      !!v || 'وارد کردن مقدار الزامی میباشد',
                                  ]"
                                  class="mx-5"
                                ></v-text-field>
                              </v-row>
                            </v-col>
                            <v-col cols="1" md="5"></v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                dense
                                outlined
                                :label="
                                  tradeRequest &&
                                  tradeRequest.request ==
                                    'ContractorRecognition'
                                    ? 'عنوان'
                                    : 'توضیحات عمومی'
                                "
                                v-model="tradeRequest.content"
                                :required="
                                  tradeRequest.content &&
                                  tradeRequest.content.length > 0
                                "
                                :rules="[
                                  (v) => {
                                    if (
                                      v &&
                                      (v.length > 4096 || v.length < 8)
                                    ) {
                                      return 'تعداد کاراکتر ها باید بین 8 تا 4096 عدد باشد';
                                    } else return true;
                                  },
                                ]"
                              ></v-text-field>
                            </v-col>

                            <v-col
                              cols="12"
                              v-if="
                                tradeRequest &&
                                tradeRequest.request == 'ContractorRecognition'
                              "
                            >
                              <v-textarea
                                dense
                                outlined
                                label="تشریح موضوع پروژه/طرح "
                                v-model="tradeRequest.orderDescription"
                                :rules="[
                                  (v) => {
                                    if (
                                      v &&
                                      (v.length > 4096 || v.length < 8)
                                    ) {
                                      return 'تعداد کاراکتر ها باید بین 8 تا 4096 عدد باشد';
                                    } else return true;
                                  },
                                ]"
                              ></v-textarea>
                            </v-col>
                            <v-col
                              cols="12"
                              v-if="
                                tradeRequest &&
                                tradeRequest.request == 'ContractorRecognition'
                              "
                            >
                              <v-text-field
                                dense
                                outlined
                                type="link"
                                label="لینک جزییات طرح"
                                v-model="tradeRequest.urlLink"
                                :rules="[
                                  (v) => {
                                    if (
                                      v &&
                                      (v.length > 4096 || v.length < 4)
                                    ) {
                                      return 'تعداد کاراکتر ها باید بین 4 تا 4096 عدد باشد';
                                    } else return true;
                                  },
                                ]"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>

                        <v-col cols="12" md="12">
                          <v-row align="center">
                            <v-col cols="10" md="4">
                              آیا محدودیت مکانی برای شرکت کنندگان مدنظرتان هست؟
                              (اختیاری)
                            </v-col>
                            <v-col cols="12" md="2">
                              <v-switch
                                v-model="limit"
                                :false-value="false"
                                :true-value="true"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" md="4" v-if="limit">
                              <v-select
                                v-model="tradeRequest.limitation"
                                :items="tradeRequestOrigin"
                                item-text="displayName"
                                item-value="title"
                                persistent-hint
                                clearable
                                hide-details
                                dense
                                outlined
                                label="نوع محدودیت"
                              ></v-select>
                            </v-col>
                            <v-col
                              cols="12"
                              md="4"
                              v-if="
                                limit &&
                                tradeRequest.limitation &&
                                tradeRequest.limitation.length
                              "
                            >
                              <v-autocomplete
                                :items="statesList"
                                multiple
                                dense
                                label="انتخاب استان"
                                small-chips
                                deletable-chips
                                outlined
                                item-text="value"
                                item-value="id"
                                v-model="stateIds"
                                :placeholder="`لیست استان های های مورد نظر خود را انتخاب کنید`"
                              >
                              </v-autocomplete>
                            </v-col>
                            <v-col
                              cols="12"
                              md="4"
                              v-if="
                                limit &&
                                tradeRequest.limitation &&
                                tradeRequest.limitation == 'City'
                              "
                              class="mt-n4"
                            >
                              <div dir="rtl">
                                <strong>
                                  {{
                                    stateIds && stateIds.length
                                      ? 'انتخاب شهر'
                                      : 'ابتدا استان های مربوطه را انتخاب کنید'
                                  }}
                                </strong>
                                <treeselect
                                  appendToBody
                                  required
                                  :flatten-search-results="true"
                                  :disable-branch-nodes="true"
                                  :show-count="true"
                                  :options="citiesList"
                                  placeholder="لیست شهرهای های مورد نظر خود را انتخاب کنید"
                                  v-model="tradeRequest.limitationIds"
                                  :normalizer="normalizerCityList"
                                  outlined
                                  :multiple="true"
                                  dense
                                  item-text="stateCityName"
                                  item-value="id"
                                />
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-sheet>
                    <v-card
                      outlined
                      v-else-if="$store.getters.tradeRequestIsEdit && !editFlag"
                    >
                      <v-card-text>
                        <v-row>
                          <v-col cols="6" md="4">
                            <label>موضوع درخواست : </label>
                            <strong>
                              {{
                                tradeRequestDisplayName(tradeRequest.request)
                              }}
                            </strong>
                          </v-col>
                          <v-col cols="6" md="4">
                            <label>نوع درخواست : </label>
                            <strong>
                              {{
                                tradeCategoryDisplayName(tradeRequest.category)
                              }}
                            </strong>
                          </v-col>
                          <v-col
                            cols="6"
                            md="4"
                            v-if="
                              tradeRequest &&
                              tradeRequest.request != 'ContractorRecognition'
                            "
                          >
                            <label>روش پرداخت/تسویه : </label>
                            <strong>
                              {{
                                paymentMethodDisplayName(
                                  tradeRequest.paymentMethod
                                )
                              }}
                            </strong>
                          </v-col>
                          <v-col cols="6" md="4" v-else>
                            <label>نوع تضمین : </label>
                            <strong>
                              {{
                                guaranteeMethodDisplayName(
                                  tradeRequest.guarantee
                                )
                              }}
                            </strong>
                          </v-col>
                          <v-col cols="6" md="4">
                            <label>مهلت شرکت در استعلام / مناقصه : </label>
                            <strong>
                              {{ tradeRequest.bidExpirationTimeInDaysFromNow }}
                              روز
                            </strong>
                          </v-col>
                          <v-col
                            cols="6"
                            md="4"
                            v-if="
                              tradeRequest &&
                              tradeRequest.request == 'ContractorRecognition'
                            "
                          >
                            <label> مدت اجرای طرح : </label>
                            <strong>
                              {{ tradeRequest.runningDuration }} ماه
                            </strong>
                          </v-col>
                          <v-col cols="12">
                            <label> َشرح سفارش: </label>
                            <strong>
                              {{ tradeRequest.content }}
                            </strong>
                          </v-col>
                          <v-col
                            cols="12"
                            v-if="
                              tradeRequest &&
                              tradeRequest.request == 'ContractorRecognition'
                            "
                          >
                            <label> َشرح موضوع پروژه: </label>
                            <strong>
                              {{ tradeRequest.orderDescription }}
                            </strong>
                          </v-col>
                          <v-col cols="12">
                            <label>محدودیت مکانی : </label>
                            <strong>
                              {{
                                limit == false
                                  ? 'ندارد'
                                  : tradeRequest.limitation == 'State'
                                  ? 'استانی'
                                  : tradeRequest.limitation == 'City'
                                  ? 'شهری'
                                  : ''
                              }}
                            </strong>
                            <div v-if="tradeRequest.limitation == 'State'">
                              <label> لیست استان ها : </label>
                              <strong v-for="state in stateName" :key="state">
                                {{ state }} ,
                              </strong>
                            </div>
                            <div v-else-if="tradeRequest.limitation == 'City'">
                              <v-col cols="12">
                                <label> لیست استان ها : </label>
                                <strong v-for="state in stateName" :key="state">
                                  {{ state }}
                                </strong>
                              </v-col>
                              <v-col cols="12">
                                <label> لیست شهرها : </label>
                                <strong v-for="city in cityName" :key="city">
                                  {{ city }} ،
                                </strong>
                              </v-col>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                    <v-btn
                      v-if="!$store.getters.tradeRequestIsEdit"
                      color="primary"
                      @click="
                        $refs.firstStep.validate()
                          ? (stepper = 2)
                          : validationErrorModal()
                      "
                      class="my-1"
                    >
                      گام بعد
                    </v-btn>
                    <div v-else>
                      <v-btn
                        v-if="!editFlag"
                        color="primary"
                        @click="editFlag = true"
                        class="my-1"
                      >
                        ویرایش اطلاعات
                      </v-btn>
                      <div v-else>
                        <v-btn
                          class="mx-2 my-1"
                          color="primary"
                          @click="editGeneralInfo()"
                        >
                          ثبت اطلاعات
                        </v-btn>
                        <v-btn
                          class="mx-2 my-1"
                          color="error"
                          @click="editFlag = false"
                        >
                          انصراف
                        </v-btn>
                      </div>
                    </div>
                  </v-form>
                </v-stepper-content>
                <!-- </v-form> -->

                <!-- -------------------------:selectedItemForEdit ="selectedItemForEdit"----------------------- -->

                <v-row>
                  <v-col>
                    <TradeRequestItemForm
                      :editBtnPressed="editBtnPressed"
                      @editBtnPressedFunc="editBtnPressedFunc"
                      :reset="reset"
                      :checkRegisterOrderOrEditOrderIsDisableFlag="
                        tradeRequest.checkRegisterOrderOrEditOrderIsDisableFlag
                      "
                      @changeReset="reset = false"
                      :stepper="stepper"
                      :bidExpirationInDays="
                        tradeRequest.bidExpirationTimeInDays
                      "
                      @changeStepper="changeStepper"
                      @changeCategory="changeCategory"
                      :category="
                        typeof tradeRequest.category == 'string'
                          ? tradeRequest.category
                          : typeof tradeRequest.category == 'object'
                          ? ''
                          : typeof tradeRequest.category == 'array' &&
                            tradeRequest.category.length
                          ? tradeRequest.category.displayName
                          : ''
                      "
                      :request="tradeRequest.request"
                    />
                  </v-col>
                </v-row>
              </v-stepper>
              <v-col cols="12" class="float-left">
                <v-spacer></v-spacer>
                <v-btn
                  class="float-left"
                  color="primary"
                  @click="addNewItem()"
                  :disabled="editFlag || $store.getters.tradeRequestEditMode"
                  v-if="
                    tradeRequest &&
                    tradeRequest.request != 'ContractorRecognition' &&
                    ((!$store.getters.tradeRequestIsEdit &&
                      !$store.getters.tradeRequestEditMode &&
                      tradeRequest.items.length != 0) ||
                      ($store.getters.tradeRequestIsEdit &&
                        !editFlag &&
                        stepper != 0))
                  "
                >
                  افزودن کالای جدید
                </v-btn>
              </v-col>
              <transition>
                <v-row
                  v-if="tradeRequest.items && tradeRequest.items.length"
                  class="my-3"
                >
                  <v-col cols="12" class="pa-3">
                    <TradeRequestItems
                      :request="tradeRequest.request"
                      :stepper="stepper"
                      @changeStepper="changeStepper"
                      :trade-request-items="tradeRequest.items"
                      @removeItem="confirmToRemoveItem"
                      @editItem="editItem"
                    />
                  </v-col>
                </v-row>
              </transition>
            </v-container>

            <v-row class="mt-2">
              <v-col cols="2"></v-col>
              <v-spacer />
              <v-col cols="10" class="float-left text-left pl-5">
                <v-btn
                  :disabled="
                    !readyToConfirm && !$store.getters.tradeRequestIsEdit
                  "
                  @click="viewReport"
                  color="success"
                >
                  بررسی جهت تایید
                </v-btn>
                <v-btn
                  :disabled="
                    tradeRequest.items.length == 0 ||
                    editFlag ||
                    submitFlag ||
                    !editBtnPressed
                  "
                  class="mx-2"
                  @click="submit"
                  color="primary"
                >
                  ثبت نهایی
                </v-btn>
                <v-btn @click="closeForm" color="error"> انصراف </v-btn>
              </v-col>
            </v-row>
          </template>
        </div>
        <v-dialog v-model="helpDialog" width="500">
          <v-card>
            <v-card-title>
              {{ help.title }}
            </v-card-title>

            <v-card-text class="mt-3">
              {{ help.text }}
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="helpDialog = false">
                فهمیدم
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <div justify="center" align="center" v-else>
        <h1>لطفا از منوی بالا یک شرکت انتخاب کنید .</h1>
      </div>
    </div>
    <div v-else>
      <TradeRequestReport
        @reportFlag="
          reportFlag = false;
          reportData = null;
        "
        :reportData="reportData"
      >
      </TradeRequestReport>
    </div>
  </div>
</template>

<script>
import TradeRequestReport from './TradeRequestReport.vue';
import asyncLoadMixin from '@/core/mixins/asyncLoadMixin';
import reusableMethodsMixin from '@/core/mixins/reusableMethodsMixin';
import TradeRequestItemForm from '@/modules/tradeRequests/components/TradeRequestItemForm.vue';
import { GET_ENUMS } from '../../enums/store/types';
import TradeRequestItems from '@/modules/tradeRequests/components/TradeRequestItems';
import Swal from 'sweetalert2';
import Multiselect from 'vue-multiselect';
import { RepoFactory } from '@/baseRepository/Factory';
import Helper from '@/core/helpers';
const merchantRepository = () => RepoFactory.get('merchant');
const tradeRequestsRepository = () => RepoFactory.get('tradeRequests');
const enumsRepository = () => RepoFactory.get('enums');
import qs from 'qs';

// const initialTradeRequest = {
//   content: null,
//   request: null,
//   category: null,
//   attachments: [],
//   limitation: null,
//   limitationIds: null,
//   bidExpirationTimeInDays: null,
//   paymentMethod: '',
//   items: [],
//   requestIsForManufaturer: null,
//   runningDuration: null,
//   guarantee: '',
//   urlLink: '',
//   orderDescription: '',
// };

export default {
  mixins: [asyncLoadMixin, reusableMethodsMixin],
  components: {
    TradeRequestItems,
    TradeRequestItemForm,
    Multiselect,
    TradeRequestReport,
  },
  data() {
    return {
      editBtnPressed: false,
      reportData: null,
      reportFlag: false,
      submitFlag: false,
      confirmationId: null,
      readyToConfirm: false,
      bidExpirationTimeInDaysFromNow: null,
      reset: false,
      tradePaymentMethodList: [],
      tradeGuaranteeList: [],
      tradeRequestTypeList: [],
      tradeCategoriesList: [],
      firstFormValid: true,
      stateName: [],
      cityName: [],
      editFlag: false,
      stateOfCities: [],
      selectedItemForEdit: null,
      tradeRequestsList: [],
      stepper: 1,
      stateIds: [],
      citiesList: [],
      statesList: [],
      limit: false,
      dayNum: 0,
      helpDialog: false,
      showCustomList: false,
      customListItems: [],
      help: {
        title: 'عنوان متن کمکی',
        text: `لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.`,
      },
      itemsTableFields: [
        {
          value: 'title',
          text: 'نام کالا',
          sortable: true,
        },

        {
          value: 'quantity',
          text: 'تعداد کالا',
          sortable: true,
        },

        {
          value: 'actions',
          text: 'عملیات',
        },
      ],

      tradeRequestOrigin: [],
      statesOrCitiesList: [],
      stateOrCitiesLabel: '',
      tradeRequest: {
        content: null,
        request: null,
        category: null,
        attachments: [],
        limitation: null,
        limitationIds: null,
        bidExpirationTimeInDays: null,
        paymentMethod: '',
        items: [],
        requestIsForManufaturer: null,
        runningDuration: null,
        guarantee: '',
        urlLink: '',
        orderDescription: '',
        checkRegisterOrderOrEditOrderIsDisableFlag: false,
      },
    };
  },
  computed: {
    tradeBaseUrl() {
      return this.$store.getters.tradeBaseUrl;
    },
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
    baseUrl() {
      return this.$store.getters.inventoryBaseUrl;
    },
    currentMerchant() {
      return this.$store.getters.currentMerchant;
    },
  },
  async created() {
    if (this.$store.getters.authorize == 'merchant') {
      const loader = this.$loading.show();
      merchantRepository()
        .getAllMerchantsByCurrentUser(this.$store.getters.merchantBaseUrl)
        .then((res) => {
          this.$store.commit('setCurrentMerchant', res.data.merchantId);
        })
        .catch((error) => Helper.handleErrors(error, this))
        .finally(() => loader.hide());
    }
    if (!this.$store.getters.allEnums.length) {
      await this.$store.dispatch(GET_ENUMS);
    }
    this.tradeCategories();
    this.tradeRequestType();
    this.tradePaymentMethod();
    this.tradeGuaranteeMethod();
  },
  beforeMount() {
    window.addEventListener('beforeunload', this.preventNav);
  },
  mounted() {
    //console.log(this.tradeRequest);
    if (
      this.$store.getters.tradeRequestIsEdit ||
      (this.$route.params.id && this.$route.params.id.length)
    ) {
      this.$store.commit('setTradeRequestIsEdit', true);
      const loader = this.$loading.show();
      tradeRequestsRepository()
        .getTradeRequestById(this.$route.params.id, this.tradeBaseUrl)
        .then((res) => {
          this.$store.commit('setTradeRequestFormStatus', true);
          this.$store.commit('setTradeRequestSelectedForEdit', res.data);
          this.$store.commit('setTradeRequestShowDetailForm', false);
          this.$store.commit('setTradeRequestSelectedForDisplay', null);
          this.fillInput();
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        })
        .finally(() => loader.hide());
    } else {
    }
    this.getCategoryTypeItems();
    this.getLimitationEnum();
  },
  destroyed() {
    this.resetForm();
  },
  methods: {
    async editGeneralInfo() {
      let app = this;
      await app.submit();
      app.editFlag = false;
      this.$store.commit('setTradeRequestIsEdit', true);
      this.$store.getters.tradeRequestIsEdit;
    },
    editBtnPressedFunc(val) {
      this.editBtnPressed = val;
    },
    getDataById(id) {
      const loader = this.$loading.show();
      tradeRequestsRepository()
        .getTradeRequestById(id, this.tradeBaseUrl)
        .then((res) => {
          this.$store.commit('setTradeRequestSelectedForEdit', res.data);
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        })
        .finally(() => loader.hide());
    },
    addNewItem() {
      this.$store.commit('setTradeRequestSingleItem', null);
      this.$store.commit('setTradeRequestEditMode', false);
      this.$store.commit('setTradeRequestSingleItemForEdit', null);
      this.stepper = 2;
      this.reset = true;
      this.tradeRequest.checkRegisterOrderOrEditOrderIsDisableFlag = false;
    },
    resetForm() {
      this.editBtnPressed = false;
      (this.reportData = null),
        (this.reportFlag = false),
        (this.submitFlag = false);
      this.tradePaymentMethodList = [];
      this.tradeGuaranteeList = [];
      this.tradeRequestTypeList = [];
      this.tradeCategoriesList = [];
      this.firstFormValid = true;
      this.stateName = [];
      this.cityName = [];
      (this.editFlag = false), (this.stateOfCities = []);
      this.selectedItemForEdit = null;
      this.tradeRequestsList = [];
      this.stepper = 1;
      this.stateIds = [];
      this.citiesList = [];
      this.statesList = [];
      this.limit = false;
      this.dayNum = 0;
      this.helpDialog = false;
      this.showCustomList = false;
      this.customListItems = [];
      this.statesOrCitiesList = [];
      this.stateOrCitiesLabel = '';
      this.tradeRequest.category = null;
      this.tradeRequest.request = '';
      this.tradeRequest.paymentMethod = '';
      this.tradeRequest.limitation = null;
      (this.tradeRequest.runningDuration = null),
        (this.tradeRequest.guarantee = ''),
        (this.tradeRequest.urlLink = ''),
        (this.tradeRequest.orderDescription = ''),
        (this.tradeRequest.limitationIds = null);
      this.tradeRequest.bidExpirationTimeInDays = null;
      this.tradeRequest.items = [];
    },
    validationErrorModal() {
      this.$dialog.error({
        text: 'وارد کردن موارد ستاره دار الزامی میباشد',
        title: 'خطا',
        persistent: true,
        actions: [
          {
            text: 'بستن',
            color: 'red',
          },
        ],
      });
    },
    changeCategory(val) {
      this.category = val;
    },
    fillInput() {
      this.getLimitationEnum();
      this.tradeRequest = this.$store.getters.tradeRequestSelectedForEdit;
      // this.tradeRequest.bidExpirationTimeInDays = this.tradeRequest.bidExpirationTimeInDaysFromNow
      this.bidExpirationTimeInDaysFromNow =
        this.tradeRequest.bidExpirationTimeInDaysFromNow;
      if (
        this.$store.getters.tradeRequestSelectedForEdit.limitation == 'State'
      ) {
        this.tradeRequest.limitation = 'State';
        this.limit = true;
        this.getStates();
        this.$store.getters.tradeRequestSelectedForEdit.limitationsDtos.forEach(
          (x) => {
            this.stateIds.push(x.id);
            this.stateName.push(x.value);
          }
        );
      }
      if (
        this.$store.getters.tradeRequestSelectedForEdit.limitation == 'City'
      ) {
        this.tradeRequest.limitation = 'City';
        this.tradeRequest.limitationIds = [];
        this.limit = true;
        this.getStates();
        this.$store.getters.tradeRequestSelectedForEdit.limitationsDtos.forEach(
          (x) => {
            this.tradeRequest.limitationIds.push(x.id);
            this.cityName.push(x.value);
            this.stateIds.push(x.stateId);
            this.stateName.push(x.stateName);
          }
        );
        this.tradeRequest.limitationIds = Array.from(
          new Set(this.tradeRequest.limitationIds)
        );
        this.stateIds = Array.from(new Set(this.stateIds));
        this.stateName = Array.from(new Set(this.stateName));

        // this.getCitiesByCityIds(this.tradeRequest.limitationIds);
      }
      this.tradeRequest.items.forEach((item) => {
        this.addItemToList(item);
      });
    },
    getCategoryTypeItems() {
      return new Promise((resolve, reject) => {
        enumsRepository()
          .getEnum('CategoryTypeItems', this.$store.getters.productBaseUrl)
          .then(({ data }) => {
            this.tradeRequestsList = data;
            resolve();
          })
          .catch((err) => {
            Helper.handleErrors(err, this);
          });
      });
    },
    changeStepper(val) {
      this.stepper = val;
    },
    async submit() {
      let body;
      if (this.$store.getters.tradeRequestIsEdit) {
        body = {
          content: this.tradeRequest.content,
          request: this.tradeRequest.request,
          category: this.tradeRequest.category,
          runningDuration: this.tradeRequest.runningDuration,
          guarantee: this.tradeRequest.guarantee,
          urlLink: this.tradeRequest.urlLink,
          orderDescription: this.tradeRequest.orderDescription,
          attachments: [],
          items: [],
          limitation: this.tradeRequest.limitation,
          limitationIds: this.tradeRequest.limitationIds,
          bidExpirationTimeInDays: this.tradeRequest.bidExpirationTimeInDays,
          paymentMethod: this.tradeRequest.paymentMethod,
          requestIsForManufaturer: this.tradeRequest.requestIsForManufaturer,
        };
        let item;
        this.tradeRequest.items.forEach((x, i) => {
          if (x.uniqueId) {
            delete x.uniqueId;
          }
          item = {
            id: x.id ? x.id : null,
            title: x.title,
            quantity: x.quantity,
            requireDateUtc: x.requireDateUtc,
            description: x.description,
            materialSupplyType: x.materialSupplyType,
            rawMaterialId: x.rawMaterialId,
            measurementUnitId: x.measurementUnitId,
            inventoryItemId: x.inventoryItemId,
            deliveryType: x.deliveryType,
            deliveryLocation: x.deliveryLocation,
            tradeRequestItemType: x.tradeRequestItemType,
            technicalHelpNeeded: x.technicalHelpNeeded,
          };
          let documents = [],
            techInfos = [],
            deliveryItems = [],
            responseDocuments = [];
          x.documents.forEach((dx, di) => {
            documents.push({
              categoryType: dx.categoryType,
              id: dx.id ? dx.id : null,
              documentTypeId: dx.documentTypeId,
              description: dx.description,
              expirationDateUtc: dx.expirationDateUtc,
              fileId:
                typeof dx.fileId == 'string' ? dx.fileId : dx.fileId.fileId,
            });
          });
          x.responseDocuments.forEach((rdx, rdi) => {
            responseDocuments.push({
              id: rdx.id ? rdx.id : null,
              documentTypeId: rdx.documentTypeId,
              isOptional: rdx.isOptional,
              subTitle: rdx.subTitle,
            });
          });
          x.techInfos.forEach((tx, ti) => {
            techInfos.push({
              id: tx.id ? tx.id : null,
              processType: tx.processType,
              productCategoryId: tx.productCategoryId,
              tradeRequestItemPropertyValues: tx.tradeRequestItemPropertyValues,
            });
          });
          x.deliveryItems.forEach((dlx, dli) => {
            deliveryItems.push({
              id: dlx.id ? dlx.id : null,
              amount: dlx.amount,
              deliveryDateUtc: dlx.deliveryDateUtc,
            });
          });
          item.documents = documents;
          item.techInfos = techInfos;
          item.responseDocuments = responseDocuments;
          item.deliveryItems = deliveryItems;
          body.items.push(item);
        });
      } else {
        console.log(this.tradeRequest);
        this.tradeRequest.items.forEach((x, i) => {
          if (x.uniqueId) {
            delete x.uniqueId;
          }
        });
        body = { ...this.tradeRequest };

        if (
          this.tradeRequest.merchantId &&
          this.tradeRequest.merchantId.length
        ) {
          body = { ...body };
        } else {
          body = {
            merchantId: this.currentMerchant,
            ...body,
          };
        }
      }
      body.items.forEach((item) => {
        if (item.document && item.document.length) {
          item.documents.forEach((x) => {
            if (x.fileUniqueId) {
              delete x.fileUniqueId; //////// have been changed
            }
          });
        }
        if (item.responseDocuments && item.responseDocuments.length) {
          item.responseDocuments.forEach((x) => {
            if (x.responseDocumentId) {
              delete x.responseDocumentId;
            }
          });
        }
        if (item.technicalHelpNeeded) {
          item.techInfos = null;
        }
      });
      console.log('body', body);
      const loader = this.$loading.show();
      if (this.$store.getters.tradeRequestIsEdit) {
        await tradeRequestsRepository()
          .editTradeRequest(this.tradeRequest.id, body, this.tradeBaseUrl)
          .then((res) => {
            this.$dialog.message.success(
              ' سفارش مورد نظر با موفقیت ویرایش شد. ',
              {
                position: 'top-left',
              }
            );
            this.submitFlag = true;
            this.confirmationId = this.tradeRequest.id;
            this.$store.commit('setTradeRequestIsEdit', false);
            this.readyToConfirm = true;
            // this.closeForm();
            loader.hide();
            this.$router.push(`/trade-request-report/${this.tradeRequest.id}`);
          })
          .catch((err) => {
            Helper.handleErrors(err, this);
            loader.hide();
          })
          .finally(() => loader.hide());
      } else {
        await tradeRequestsRepository()
          .addTradeRequest(body, this.tradeBaseUrl)
          .then((res) => {
            this.$dialog.message.success(' سفارش جدید با موفقیت ثبت گردید. ', {
              position: 'top-left',
            });
            this.submitFlag = true;
            this.readyToConfirm = true;
            this.confirmationId = res.data.id;
            // this.closeForm();
            this.getDataById(this.confirmationId);
            loader.hide();
            this.$router.push(`/trade-request-report/${res.data.id}`);
          })
          .catch((err) => {
            Helper.handleErrors(err, this);
            loader.hide();
          })
          .finally(() => loader.hide());
      }
    },
    addDaysToDate(intDays) {
      var currentDateObj = new Date();
      var numberOfMlSeconds = currentDateObj.getTime();
      var addMlSeconds = intDays * 24 * 60 * 60 * 1000;
      var newDateObj = new Date(numberOfMlSeconds + addMlSeconds);
      return newDateObj;
    },
    getLimitationEnum() {
      enumsRepository()
        .getEnum('TradeRequestLimitationType', this.tradeBaseUrl)
        .then((res) => {
          this.tradeRequestOrigin = res.data.filter((x) => {
            if (x.title != 'Country') return x;
          });
        })
        .catch((err) => Helper.handleErrors(err, this));
    },
    openHelpModal() {
      // Send Request To Get Help Text
      this.helpDialog = true;
    },
    preventNav(event) {
      event.preventDefault();
      event.returnValue = '';
    },
    addItemToList(item) {
      let app = this;
      if (
        !this.$store.getters.tradeRequestEditMode &&
        !this.$store.getters.tradeRequestIsEdit
      ) {
        //create new Item
        if (item && Object.keys(item).length) {
          this.$store.commit('addItemToTradeRequestItems', item);
          app.tradeRequest.items = [];
          app.tradeRequest.items = this.$store.getters.tradeRequestItems;
          this.$store.commit('setTradeRequestSingleItem', null);
          return;
        }
      } else if (
        this.$store.getters.tradeRequestEditMode &&
        !this.$store.getters.tradeRequestIsEdit
      ) {
        //edit an Item in a new tradeRequest form
        this.$store.getters.tradeRequestItems.forEach((x, i) => {
          if (x.uniqueId && item.uniqueId && x.uniqueId == item.uniqueId) {
            app.tradeRequest.items[i] = item;
            this.$store.commit('setTradeRequestItems', app.tradeRequest.items);
            app.tradeRequest.items = [];
            this.$store.commit('setTradeRequestSingleItemForEdit', null);
            app.tradeRequest.items = this.$store.getters.tradeRequestItems;
            this.$store.commit('setTradeRequestSingleItem', null);
            this.$store.commit('setTradeRequestEditMode', false);
            return;
          }
        });
      } else if (
        !this.$store.getters.tradeRequestEditMode &&
        this.$store.getters.tradeRequestIsEdit
      ) {
        //when user edits one form, the items should be added to itemList
        if (item && Object.keys(item).length) {
          this.$store.commit('addItemToTradeRequestItems', item);
          app.tradeRequest.items = [];
          app.tradeRequest.items = this.$store.getters.tradeRequestItems;
          this.$store.commit('setTradeRequestSingleItem', null);
          return;
        }
      } else if (
        this.$store.getters.tradeRequestEditMode &&
        this.$store.getters.tradeRequestIsEdit
      ) {
        //either tradeRequestEditMode and StoreEdit Mode... when user wants to edit an item of previously created form

        if (
          this.$store.getters.tradeRequestItems &&
          this.$store.getters.tradeRequestItems.length
        ) {
          this.$store.getters.tradeRequestItems.forEach((x, i) => {
            if (x.id && x.id == item.id) {
              app.tradeRequest.items[i] = item;
              this.$store.commit(
                'setTradeRequestItems',
                app.tradeRequest.items
              );
              app.tradeRequest.items = [];
              app.tradeRequest.items = this.$store.getters.tradeRequestItems;
              this.$store.commit('setTradeRequestSingleItem', null);
              this.$store.commit('setTradeRequestEditMode', false);
              this.$store.commit('setTradeRequestSingleItemForEdit', null);
              return;
            } else if (!x.id) {
              this.$dialog.error({
                text: 'ooops!store edit mode without id',
                title: 'خطا',
                persistent: true,
                actions: [
                  {
                    text: 'بستن',
                    color: 'red',
                  },
                ],
              });
            }
          });
        }
      }
    },
    confirmToRemoveItem(item) {
      Swal.fire({
        text: 'برای حذف این مورد مطمئن هستید؟',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        cancelButtonText: 'خیر(لغو)',
        confirmButtonText: 'حذف',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.removeItem(item);
        }
      });
    },
    removeItem(item) {
      this.$store.getters.tradeRequestItems.splice(
        this.$store.getters.tradeRequestItems.indexOf(
          this.$store.getters.tradeRequestItems.find((el) => el.id === item.id)
        ),
        1
      );
      // this.tradeRequestItems =[]
      // this.tradeRequestItems =this.$store.getters.tradeRequestItems
      this.tradeRequest.items = [];
      this.tradeRequest.items = this.$store.getters.tradeRequestItems;
    },
    closeForm() {
      this.$store.commit('setTradeRequestSelectedForEdit', null);
      this.$store.commit('setTradeRequestSelectedForDisplay', null);
      this.$store.commit('setTradeRequestSingleItemForEdit', null);
      this.$store.commit('setTradeRequestItems', []);
      this.$store.commit('setTradeRequestSingleItem', null);
      this.$store.commit('setAllTradeRequests', []);
      this.$store.commit('setTradeRequestFormStatus', false);
      this.$store.commit('setTradeRequestIsEdit', false);
      this.$store.commit('setTradeRequestEditMode', false);
      this.$store.commit('setTradeRequestShowDetailForm', false);
      this.resetForm();
      this.$router.push({ path: '/trade-request' });
    },
    editItem(item) {
      this.editBtnPressed = false;
      this.$store.commit('setTradeRequestEditMode', true);
      this.$store.commit('setTradeRequestSingleItemForEdit', item);
    },
    tradeCategoryDisplayName(title) {
      if (this.tradeCategoriesList.length) {
        let result = this.tradeCategoriesList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    tradeRequestDisplayName(title) {
      if (this.tradeRequestTypeList.length) {
        let result = this.tradeRequestTypeList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    paymentMethodDisplayName(title) {
      if (this.tradePaymentMethodList.length) {
        let result = this.tradePaymentMethodList.find(
          (el) => el.title == title
        );
        if (result) return result.displayName;
      }
    },
    guaranteeMethodDisplayName(title) {
      if (this.tradeGuaranteeList.length) {
        let result = this.tradeGuaranteeList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    tradeGuaranteeMethod() {
      this.tradeGuaranteeList = this.getEnumByTitle('GuaranteeType');
    },
    tradeCategories() {
      this.tradeCategoriesList = this.getEnumByTitle('CategoryTypeItems');
    },
    tradeRequestType() {
      this.tradeRequestTypeList = this.getEnumByTitle('TradeRequestType');
    },
    tradePaymentMethod() {
      this.tradePaymentMethodList = this.getEnumByTitle(
        'TradePaymentMethodType'
      );
    },

    rawMaterialSupplyTypes() {
      return this.getEnumByTitle('RawMaterialSupplyType');
    },
    getStates() {
      merchantRepository()
        .getProvince(this.merchantBaseUrl)
        .then((res) => {
          this.statesList = res.data;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        });
    },
    getCitiesByStateIds() {
      let params = {
        stateIds: this.stateIds,
      };
      merchantRepository()
        .getCitiesOfMultipleStatesTree(
          this.merchantBaseUrl,
          params,
          {},
          (params) => {
            return qs.stringify(params, { arrayFormat: 'repeat' });
          }
        )
        .then((res) => {
          this.citiesList = res.data;
        });
    },

    normalizerCityList(content) {
      let object = {
        isDisabled: content.disabled,
        id: content.id,
        label: content.value,
      };
      if (content.cityList && content.cityList.length) {
        object.children = content.cityList;
      } else {
        delete content.cityList;
      }

      return object;
    },
    viewReport() {
      this.submitFlag = false;
      this.reportFlag = true;
      this.reportData = this.$store.getters.tradeRequestSelectedForEdit;
    },
    requestTypeSelectionChange() {
      //alert(this.tradeRequest.request)
      if (this.tradeRequest.request == 'DirectOrder') {
         this.tradeRequest.request = '';
        this.$dialog.warning({
          text: 'برای ثبت سفارش مستقیم، از منوی مربوط استفاده کنید یا میتوانید از لینک زیر اقدام کنید <a href="trade-request-direct-form"> فرم ثبت سفارش مستقیم </a> ',
          title: 'دقت',
          persistent: true,
          actions: [
            {
              text: 'بستن',
              color: 'red',
            },
          ],
        });
        this.tradeRequest.request = '';
      }
    },
  },
  watch: {
    bidExpirationTimeInDaysFromNow() {
      this.tradeRequest.bidExpirationTimeInDays =
        this.bidExpirationTimeInDaysFromNow;
    },
    stateIds() {
      if (this.tradeRequest.limitation == 'City' && this.stateIds.length) {
        this.getCitiesByStateIds();
      } else if (
        this.tradeRequest.limitation == 'State' &&
        this.stateIds.length
      ) {
        this.tradeRequest.limitationIds = this.stateIds;
      }
      if (this.stateIds == [] || this.stateIds == '' || this.stateIds == null) {
        this.citiesList = [];
        this.tradeRequest.limitationIds = null;
      }
    },

    limit() {
      if (this.limit == false) {
        this.stateIds = [];
        this.citiesList = [];
        this.statesList = [];
        this.limitationId = null;
        this.tradeRequest.limitation = null;
      }
    },
    'tradeRequest.limitation': function () {
      if (this.$store.getters.tradeRequestIsEdit) {
        this.getStates();
      } else {
        this.stateIds = [];
        this.getStates();
      }
    },
    'tradeRequest.category': function () {
      if (this.tradeRequest.category != 'Product') {
        this.tradeRequest.requestIsForManufaturer = null;
      } else if (!this.$store.getters.tradeRequestIsEdit) {
        this.tradeRequest.requestIsForManufaturer = false;
      }
      this.$store.commit(
        'setTradeRequestCategoryType',
        this.tradeRequest.category
      );
    },
    '$store.getters.tradeRequestSingleItem': function () {
      if (
        this.$store.getters.tradeRequestSingleItem &&
        Object.keys(this.$store.getters.tradeRequestSingleItem).length
      ) {
        this.addItemToList(this.$store.getters.tradeRequestSingleItem);
      }
    },
    '$store.getters.tradeRequestItems': function () {
      this.tradeRequest.items = [];
      this.tradeRequest.items = this.$store.getters.tradeRequestItems;
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
/* .vue-treeselect__menu-container div {
  z-index: 999999999;
} */
</style>
